import { ReactNode } from 'react';
import {
    ColumnDefinition,
    ColumnTableHeader,
    getSortDir,
    SortColumnTableHeaderFactory,
    TableSort,
} from './SortedTableHeader';

const SortColumnTableHeader = SortColumnTableHeaderFactory<any>();

type TableHeaderProps<TableColumnEnum extends string> = {
    columnDefinition: ColumnDefinition<TableColumnEnum>[];
    sorting: TableSort<TableColumnEnum>;
    setSorting: (sort: TableSort<TableColumnEnum>) => void;
    selectionHeader?: ReactNode;
};

export const TableHeader = <TableColumnEnum extends string>({
    columnDefinition,
    sorting,
    setSorting,
    selectionHeader,
}: TableHeaderProps<TableColumnEnum>) => (
    <thead>
        <tr>
            {selectionHeader && <th className="table-checkbox">{selectionHeader}</th>}
            {columnDefinition.map((def) =>
                def.sortable ? (
                    <SortColumnTableHeader
                        key={def.column}
                        labelId={def.labelId}
                        col={def.column}
                        currentSort={sorting}
                        sortingHandler={(column: TableColumnEnum) =>
                            setSorting({ column, dir: getSortDir(column, sorting) })
                        }
                    />
                ) : (
                    <ColumnTableHeader key={def.column} labelId={def.labelId} />
                ),
            )}
        </tr>
    </thead>
);
